import React, { MouseEvent } from 'react';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const MapIcon = ({ className, onClick }: Props) => {
  const { themeName } = useThemeContext();
  const isExpTheme = themeName && themeName !== ThemeNames.ZOOCASA;

  return (
    <>
      { !isExpTheme ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" className={className} onClick={onClick}>
          <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill="#000" fillRule="nonzero">
              <path d="M33.889.123L23.58 3.929 12.857.117a1.443 1.443 0 00-.468-.081H1.397C.625.036 0 .662 0 1.433v25.011c0 .772.625 1.397 1.397 1.397h10.751l10.975 3.902c.323.115.667.1.951-.006l10.783-3.982c.548-.203.913-.726.913-1.31V1.432c0-.971-.97-1.647-1.881-1.31zM10.992 25.047H2.795V2.83h8.197v22.216zm11.201 3.4l-8.406-2.99V3.414l8.406 2.989v22.045zm10.783-2.976l-7.988 2.95V6.389l7.988-2.95V25.47z"></path>
            </g>
          </g>
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" className={className} onClick={onClick}>
          <g clipPath="url(#clip0_1244_10018)">
            <path d="M17.0833 2.5L16.95 2.525L12.5 4.25L7.5 2.5L2.8 4.08333C2.625 4.14167 2.5 4.29167 2.5 4.48333V17.0833C2.5 17.3167 2.68333 17.5 2.91667 17.5L3.05 17.475L7.5 15.75L12.5 17.5L17.2 15.9167C17.375 15.8583 17.5 15.7083 17.5 15.5167V2.91667C17.5 2.68333 17.3167 2.5 17.0833 2.5ZM8.33333 4.55833L11.6667 5.725V15.4417L8.33333 14.275V4.55833ZM4.16667 5.38333L6.66667 4.54167V14.2917L4.16667 15.2583V5.38333ZM15.8333 14.6167L13.3333 15.4583V5.71667L15.8333 4.75V14.6167Z" fill="#0C0F24"/>
          </g>
          <defs>
            <clipPath id="clip0_1244_10018">
              <rect width="20" height="20" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default MapIcon;
